import { createSlice } from "@reduxjs/toolkit";
import { sagaActions } from "../sagas/sagaActions";

const initialState = {
  isLoading: false,
  error: undefined,
};

export const loaderSlice = createSlice({
  name: "loader",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(sagaActions.API_CALL_START, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(sagaActions.API_CALL_END, (state) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(sagaActions.API_FAILED, (state, action) => {
        state.isLoading = false;
        state.error = action.message;
      });
  },
});

export default loaderSlice.reducer;
